export default "__VITE_ASSET__90b3cd0a__"